import { StyleProp, View, ViewStyle } from 'react-native'
import { LocalVideoTrack, RemoteUser, useRemoteUsers } from 'agora-rtc-react'
import { useWebLocalCameraTrack } from '../../../hooks/av/useAgoraCall.web'

type PlayerCellVideoProps = {
  videoStyle?: StyleProp<ViewStyle>
  playerId?: number
  channelName?: string
}

export const PlayerCellVideo = ({ playerId = 0, videoStyle }: PlayerCellVideoProps) => {
  const remoteUsers = useRemoteUsers()
  const remoteUser = remoteUsers.find((u) => Number(u.uid) === playerId)
  const localCameraTrack = useWebLocalCameraTrack()

  return (
    <View style={[{ overflow: 'hidden', borderRadius: 8 }, videoStyle]}>
      {playerId === 0 ? (
        <LocalVideoTrack track={localCameraTrack} play style={{ width: '100%', height: '100%' }} />
      ) : (
        <View style={{ flex: 1 }}>{remoteUser && <RemoteUser user={remoteUser} />}</View>
      )}
    </View>
  )
}
